//import axios from 'axios';

export default class UtilService {

    

    defineError(err) {
        
        let errResponse = err.response;

        

        


        if (errResponse && errResponse.data) {
            let errorData = errResponse.data;
            
            let errorClass = errorData.error_class;
            let errorDescription = errorData.error_description;
            
            this.consoleLog('ErrorClass:', errorClass);
            this.consoleLog('ErrorDescription:', errorDescription);

            return { 
                    "errorClass": errorClass?errorClass:"RuntimeException",        
                    "errorDescription": errorDescription?errorDescription:"Error occurred wile processing request!"
                };

        } else {
            let errorMsg = err.message;  
            if(errorMsg){
                this.consoleLog("ErrorMsg:",errorMsg);          
            }else{
                this.consoleLog("Error:",err);
            }
            return { 
                "errorClass": "RuntimeException",        
                "errorDescription": errorMsg?errorMsg:"Error occurred wile processing request!"
            };
        }

        
    }

    consoleLog(msg,obj){

        if(process.env.VUE_APP_DEBUG==='YES'){
            console.log("///// CONSOLE OUTPUT /////");
            if(msg&&obj){
                console.log(""+msg,obj);
            }else{
                if(msg){
                    console.log(msg);
                }
            }
            //console.log("/////////////////////////");
            console.log("-------------------------");
        }
    }
}
